import { InjectionToken } from '@angular/core';

export const INTEGRATION_URL = new InjectionToken<string>(
  'integrationEntrypoint',
);
export const INTEGRATION_SUBSCRIPTION_KEY = new InjectionToken<string>(
  'integrationSubscriptionKey',
);
export const APP_STORE_OAUTH_URL = new InjectionToken<string>(
  'appStoreOAuthUrl',
);
export const APP_STORE_CONFIGURATION_URL = new InjectionToken<string>(
  'appStoreConfigurationUrl',
);
export const INTEGRATION_WEBHOOK_URL = new InjectionToken<string>(
  'integrationWebhookUrl',
);
export const GRAPH_API_SCOPES = new InjectionToken<string[]>('graphApiScopes');
export const GRAPH_API_URI = new InjectionToken<string>('graphApiUri');
export const ON_PREM_CLIENT_ID = new InjectionToken<string[]>('onPremClientId');
export const HTTP_TIMEOUT = new InjectionToken<string[]>('httpTimeout');
export const HTTP_RETRY_AMOUNT = new InjectionToken<string[]>(
  'httpRetryAmount',
);
